module.exports = __webpack_public_path__ + "static/media/phonebook_1.e03a974c.png";